import { render } from "./SaveImmigration.vue?vue&type=template&id=15aa821e&scoped=true"
import script from "./SaveImmigration.vue?vue&type=script&lang=js"
export * from "./SaveImmigration.vue?vue&type=script&lang=js"

import "./SaveImmigration.vue?vue&type=style&index=0&id=15aa821e&scoped=true&lang=scss"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15aa821e"]])

export default __exports__